import { useRef, useState } from 'react';
import { FormattedMessage, useIntl } from 'react-intl';

import { Button, Input } from '@mui/material';
import Popover from '@mui/material/Popover';

import { PopoverActions, PopoverContent, PopoverHelp, PopoverMessageContainer } from './styled';

interface WordInputProps {
  word: string;
  onSave: (word: string, idx: number) => void;
  onReplaceAll: (new_voice_label: string, label: string) => void;
  idx: number;
}

export function WordInput({ word, onSave, onReplaceAll, idx }: WordInputProps) {
  const [wordBuffer, setWordBuffer] = useState<string>(word);
  const [anchorEl, setAnchorEl] = useState<HTMLButtonElement | null>(null);
  const inputRef = useRef<HTMLInputElement>(null);
  const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const open = Boolean(anchorEl);
  const id = open ? 'simple-popover' : undefined;

  const handleReplaceAll = () => {
    onReplaceAll(wordBuffer, word);
    handleClose();
  };

  const handleReplace = () => {
    onSave(wordBuffer, idx);
    handleClose();
  };

  const handleCancel = () => {
    setWordBuffer(word);
    handleClose();
  };

  const { formatMessage } = useIntl();

  const tooltipHelp = formatMessage({
    id: 'fragments.wordEditor.tooltipHelp',
    defaultMessage: 'Presiona enter para guardar o escape para cancelar',
  });

  return (
    <>
      <Popover
        id={id}
        open={open}
        anchorEl={anchorEl}
        onClose={handleClose}
        anchorOrigin={{
          vertical: -30,
          horizontal: 'left',
        }}
      >
        <PopoverContent>
          <PopoverMessageContainer>
            <PopoverHelp>{tooltipHelp}</PopoverHelp>
            <Input
              ref={inputRef}
              type="text"
              value={wordBuffer}
              style={{ width: '100%' }}
              onChange={(e) => setWordBuffer(e.target.value)}
            />
          </PopoverMessageContainer>
          <PopoverActions>
            <Button size="small" variant="outlined" onClick={handleCancel}>
              <FormattedMessage id="common.cancel" defaultMessage="Cancelar" />
            </Button>
            <Button size="small" variant="outlined" onClick={handleReplaceAll}>
              <FormattedMessage
                id="fragments.transcription.replaceAll"
                defaultMessage="Replace all"
              />
            </Button>
            <Button size="small" variant="contained" onClick={handleReplace}>
              <FormattedMessage id="fragments.transcription.replace" defaultMessage="Replace" />
            </Button>
          </PopoverActions>
        </PopoverContent>
      </Popover>
      <span onClick={handleClick}>{wordBuffer}</span>
    </>
  );
}
